import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Dashboard from "@/pages/Dashboard";
import ResumeDetail from "@/pages/ResumeDetail";
import SharedResume from "@/pages/SharedResume";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0 } }} />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/resume/:id" element={<ResumeDetail />} />
          <Route path="/share/:token" element={<SharedResume />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
